import React from 'react';
import './AppShell.css';

/**
 * AppShell - Shared application shell for Landing and Chat views
 * Provides unified navbar (DBS logo, avatar, AGENT ACTIVE, actions) and centered content container
 */
const AppShell = ({
  children,
  showBackButton = false,
  onBackClick,
  showAgentStatus = false,
  onToggleSettings,
  onNavigateToGraph,
  onCloseGraph,
  isGraphViewOpen = false,
  userName
}) => {
  const Icon = ({ name }) => {
    const common = {
      className: 'icon',
      width: 18,
      height: 18,
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
      'aria-hidden': true
    };

    if (name === 'settings') {
      return (
        <svg {...common}>
          <path
            d="M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"
            stroke="currentColor"
            strokeWidth="1.8"
          />
          <path
            d="M19.4 15a8.6 8.6 0 0 0 .05-1l2.02-1.57a1 1 0 0 0 .23-1.28l-1.9-3.29a1 1 0 0 0-1.22-.44l-2.38.96a8.53 8.53 0 0 0-1.74-1.01l-.36-2.54A1 1 0 0 0 12.1 2h-3.8a1 1 0 0 0-.99.83l-.36 2.54c-.62.25-1.2.58-1.74 1.01l-2.38-.96a1 1 0 0 0-1.22.44L.7 11.15a1 1 0 0 0 .23 1.28L2.95 14c-.03.33-.05.66-.05 1s.02.67.05 1l-2.02 1.57a1 1 0 0 0-.23 1.28l1.9 3.29a1 1 0 0 0 1.22.44l2.38-.96c.54.43 1.12.76 1.74 1.01l.36 2.54a1 1 0 0 0 .99.83h3.8a1 1 0 0 0 .99-.83l.36-2.54c.62-.25 1.2-.58 1.74-1.01l2.38.96a1 1 0 0 0 1.22-.44l1.9-3.29a1 1 0 0 0-.23-1.28L19.4 16Z"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinejoin="round"
            opacity="0.95"
          />
        </svg>
      );
    }

    // name === 'graph'
    return (
      <svg {...common}>
        <path
          d="M7 18V11M12 18V6M17 18v-8"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M5 18h14"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          opacity="0.9"
        />
      </svg>
    );
  };

  return (
    <div className="app-shell">
      {/* Shared Navigation Bar - Two Rows */}
      <nav className="app-navbar">
        {/* Row 1: Logo (left) | Actions (right) */}
        <div className="nav-row nav-row-top">
          <div className="nav-left-top">
            <img 
              src="https://1000logos.net/wp-content/uploads/2021/05/DBS-Bank-logo.png" 
              alt="DBS Logo" 
              className="nav-logo"
              style={{display:'none'}}
            />
          </div>
          <div className="nav-right-top">
            <div className="nav-actions">
              {onNavigateToGraph && !isGraphViewOpen && (
                <button
                  className="nav-action-btn"
                  onClick={onNavigateToGraph}
                  title="View Agent Flow Graph"
                  aria-label="View Agent Flow Graph"
                  type="button"
                >
                  <Icon name="graph" />
                </button>
              )}
              {isGraphViewOpen && onCloseGraph && (
                <button
                  className="nav-action-btn active"
                  onClick={onCloseGraph}
                  title="Close Graph View"
                  aria-label="Close Graph View"
                  type="button"
                >
                  <Icon name="graph" />
                </button>
              )}
              {onToggleSettings && (
                <button
                  className="nav-action-btn"
                  onClick={onToggleSettings}
                  title="Settings"
                  aria-label="Settings"
                  type="button"
                >
                  <Icon name="settings" />
                </button>
              )}
            </div>
            <div className="nav-avatar">{userName ? userName.charAt(0).toUpperCase() : 'E'}</div>
          </div>
        </div>
        
        {/* Row 2: Back to Explore (left) | Agent Active (right) */}
        {(showBackButton || showAgentStatus) && (
          <div className="nav-row nav-row-bottom">
            <div className="nav-left-bottom">
              {showBackButton && onBackClick && (
                <button
                  className="back-link"
                  onClick={onBackClick}
                  title="Back to Explore"
                  aria-label="Back to Explore"
                >
                  <i className="fas fa-chevron-left"></i>
                  <span>Back to Explore</span>
                </button>
              )}
            </div>
            <div className="nav-right-bottom">
              {showAgentStatus && (
                <div className="agent-status">
                  <span className="status-dot"></span>
                  <span>AGENT ACTIVE</span>
                </div>
              )}
            </div>
          </div>
        )}
      </nav>

      {/* Centered Content Container */}
      <main className="app-main">
        {children}
      </main>
    </div>
  );
};

export default AppShell;
